import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from './root';
import { getSession } from '@/lib/auth-client';
import { consoleAccess } from '@/lib/console-admin';
import { PermissionProvider } from '@/lib/permissions';
import { RouteError } from '@/admin/ConsoleRouteError';
import { reportRenderError } from '@/lib/rum';

// The live-analytics oversight page. Lazy-loaded so the cockpit's
// chunk never pays for it; admin-gated the same way, with the JWT riding
// per-request on the /bff/reports and /bff/admin calls.

function LiveGate() {
  const { userEmail, role } = liveRoute.useRouteContext();
  return (
    <PermissionProvider role={role}>
      <LazyLiveAnalyticsPage userEmail={userEmail} />
    </PermissionProvider>
  );
}

const LazyLiveAnalyticsPage = lazyRouteComponent(() => import('@/admin/LiveAnalyticsPage'));

export const liveRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/live',
  // Same gate as /console: this page's /bff/reports/* and /bff/admin/* reads
  // are admin-gated, so a non-admin would get an error wall rather than a page.
  beforeLoad: async () => {
    const { data } = await getSession();
    if (!data) throw redirect({ to: '/login' });
    const { allowed, role } = await consoleAccess();
    if (!allowed) throw redirect({ to: '/' });
    return { userEmail: data.user.email, role };
  },
  component: LiveGate,
  // Loaded on demand, so this also catches a chunk that fails to arrive.
  errorComponent: RouteError,
  onCatch: (error) => reportRenderError(error, 'route:live'),
});
